import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

const ScrollProgress: React.FC = () => {
  const { scrollYProgress } = useScroll();
  
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-orange-600 via-orange-400 to-orange-200 origin-left z-[100]"
      style={{ scaleX }}
    >
        {/* Glow effect */}
        <div className="absolute top-0 right-0 bottom-0 w-24 bg-gradient-to-r from-transparent to-orange-100 opacity-50 blur-sm" />
    </motion.div>
  );
};

export default ScrollProgress;